<template>
  <div class="ushk-content">
    <div class="ushk-content-box" ref="main">
      <div class="ushk-news">
        <div class="ushk-news__h ushk-news__h_tabs">
          <div @click="onChannelChange(0)" class="ushk-news__logo">
            <i></i>
          </div>
          <div class="ushk-news__h_tabs">
            <div
              v-for="(item, index) in channels"
              :key="index"
              class="ushk-news__h_tab"
              :class="{active: channelId === item.id}"
              @click="onChannelChange(item.id)"
            >
              {{ item.title }}
            </div>
          </div>

          <div class="ushk-news__handle">
            <ushk-switch v-model="isOpenNotice" text="通知"></ushk-switch>
            <ushk-switch v-model="isOpenVoice" text="声音"></ushk-switch>
            <ushk-switch v-model="onlyImportant"  @input="onOnlyImChange" text="只看重要"></ushk-switch>
          </div>
        </div>
        <div class="ushk-news__b">
          <flash-list
            :currentChannel="channelId"
            :is-open-notice="isOpenNotice"
            :is-open-voice="isOpenVoice"
            :only-important="onlyImportant"
          ></flash-list>
        </div>
      </div>
    </div>
    <div class="ushk-side">
      <div class="ushk-side__wrap" :style="{left: sideLeft}">
        <ad></ad>
        <contract></contract>
        <Declatration></Declatration>
      </div>
    </div>
  </div>
</template>
<script>
import {cookie, storage} from '@/commons/utils'
import {device} from '@/commons'
const STORE_ONLYIM = 'onlyIm'

export default {
  name: 'Home',
  data () {
    return {
      isOpenNotice: true,
      isOpenVoice: true,
      onlyImportant: false,
      autoFixed: false,
      sideLeft: 'inherit',
      channelId: 0,
      channels: [
        {id: 0, title: device.isMobile ? '全部' : '全部快讯'},
        {id: 1, title: '美股'},
        {id: 2, title: '港股'}
      ]
    }
  },
  watch: {
    isOpenNotice (v) {
      cookie.set('onNotification', v ? 1 : 2)
    },
    isOpenVoice (v) {
      cookie.set('onSound', v ? 1 : 2)
    },
    onlyImportant (v) {
      cookie.set('onImportant', v ? 1 : 2)
    }
  },
  mounted () {
    // this.init()
    this.getSwitchState()
    if (device.isMobile) {
      new Jin10AppLauncher({
        openBlank: true,
        website: 'ushknews'
      })
    }
    this.$nextTick(function () {
      window.addEventListener('resize', this.onScroll)
      window.addEventListener('scroll', this.onScroll)
    })
  },
  methods: {
    init () {
      document.addEventListener('visibilitychange', function () {
        if (document.visibilityState == 'visible') {
          location.reload(true)
        }
      })
      document.addEventListener('webkitvisibilitychange', function () {
        if (document.webkitVisibilityState == 'visible') {
          location.reload(true)
        }
      })
      document.addEventListener('mozvisibilitychange', function () {
        if (document.mozVisibilityState == 'visible') {
          location.reload(true)
        }
      })
      document.addEventListener('msvisibilitychange', function () {
        if (document.msVisibilityState == 'visible') {
          location.reload(true)
        }
      })
    },
    onOnlyImChange (value) {
      const store = storage.get(STORE_ONLYIM) || {}

      store[this.channelId] = value
      this.onlyImportant = value

      storage.set(STORE_ONLYIM, store)
    },
    onChannelChange (id) {
      this.channelId = id
      window.jin_us_flash_channel = id
      const store = storage.get(STORE_ONLYIM) || {}

      this.onlyImportant = !!store[id]
    },
    getSwitchState () {
      let notificationCookie = cookie.get('onNotification')
      let voiceCookie = cookie.get('onSound')

      if (!notificationCookie) {
        cookie.set('onNotification', 1)
        notificationCookie = 1
      }
      if (!voiceCookie) {
        cookie.set('onSound', 1)
        voiceCookie = 1
      }
      this.isOpenNotice = notificationCookie == 1
      this.isOpenVoice = voiceCookie == 1
      this.onChannelChange(0)
    },

    onScroll () {
      let scrollY =
        document.documentElement.scrollTop || document.body.scrollTop
      let scrollX =
        document.documentElement.scrollLeft || document.body.scrollLeft
      // 纵向滚动
      let headerHeight = null
      let header = document.querySelector('.ushk-header')
      if (header) {
        headerHeight = header.offsetHeight
      }
      // 当滚动的距离等于header的高度，改变side定位为fixed
      this.autoFixed = scrollY >= headerHeight

      // 水平滚动
      let mainWidth = this.$refs.main.clientWidth
      let mediaMatch = window.matchMedia('(max-width:1240px)')
      // 当屏幕宽度小于1240(出现滚动条) side是固定定位的时候
      if (mediaMatch.matches && this.autoFixed) {
        // 50为padding间距
        this.sideLeft = mainWidth + 50 - scrollX + 'px'
      } else {
        this.sideLeft = 'inherit'
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// home.vue?9ed08478